import { render } from "./LoadingDiv.vue?vue&type=template&id=d9895b76"
import script from "./LoadingDiv.vue?vue&type=script&lang=js"
export * from "./LoadingDiv.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__